var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.15 20.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.95,16.2c-.3-.37-.65-.77-.97-1.19-1.05-1.43-2.15-2.82-2.67-4.56-.24-.79-.36-1.6-.29-2.42.14-1.8.73-3.43,1.88-4.83.86-1.04,1.85-1.91,3.09-2.46C5.99.3,7.02,0,8.14,0c1.06,0,2.1.03,3.12.38,1.05.36,2,.89,2.85,1.61,1.34,1.13,2.27,2.52,2.73,4.2.49,1.82.46,3.61-.39,5.35-.65,1.32-1.49,2.5-2.4,3.64-.8.99-1.66,1.94-2.51,2.9-.5.56-1.01,1.12-1.53,1.66-.83.85-1.99.83-2.81.04-.63-.62-1.23-1.28-1.78-1.97l-1.46-1.59ZM8.52,1.29c-.47.06-.95.1-1.41.18-1.21.22-2.28.77-3.2,1.57-.93.81-1.64,1.79-2.08,2.96-.4,1.06-.58,2.16-.41,3.29.15,1,.58,1.9,1.12,2.75,1.27,2.01,2.84,3.79,4.45,5.53.35.37.69.76,1.02,1.14.32.37.71.4,1.06.06.27-.27.53-.56.79-.85.7-.78,1.39-1.58,2.1-2.35.94-1.02,1.74-2.14,2.52-3.29,1.07-1.56,1.59-3.25,1.19-5.15-.35-1.67-1.16-3.05-2.48-4.14-1.36-1.13-2.9-1.7-4.68-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.64,8.52c.12,2.26-1.9,4.12-4.1,4.11-2.15-.02-4.12-1.79-4.04-4.27.07-2.1,1.75-3.95,4.14-3.93,2.16.02,4.12,1.85,4,4.09ZM8.59,5.82c-1.55-.12-2.76,1.25-2.76,2.67,0,1.49,1.19,2.78,2.77,2.77,1.45,0,2.65-1.26,2.73-2.61.09-1.61-1.33-2.96-2.73-2.84Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinMap);
export default __webpack_public_path__ + "static/media/pinMap.46c2cb47655ef4c7aa79ee2eb41788a1.svg";
export { ForwardRef as ReactComponent };